import { render, staticRenderFns } from "./ResourcePicker.vue?vue&type=template&id=40095d84&scoped=true"
import script from "./ResourcePicker.vue?vue&type=script&lang=js"
export * from "./ResourcePicker.vue?vue&type=script&lang=js"
import style0 from "./ResourcePicker.vue?vue&type=style&index=0&id=40095d84&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40095d84",
  null
  
)

export default component.exports